// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/carousel/style/index.less
// module id = 1009
// module chunks = 1